import React, { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import TextField from '@mui/material/TextField';

import type { PayingAccountField } from '@/domain/paySettings/schemas';

import { assembleIban } from '@/pages/dokkaPay/pages/configurations/company/pages/paymentProviders/components/Providers/components/DialogPaymentProviderDetails/components/DialogAddGlobalAccount/components/PayingAccountForm/form';

type Props = {
  field: PayingAccountField;
  fields: PayingAccountField[];
};

// Keeps the field's value assembled from its `computedFrom` parts; shown read-only unless hidden.
const IbanField = ({ field, fields }: Props) => {
  const { control, setValue } = useFormContext();
  const values = useWatch({ control });
  const iban = assembleIban(field, fields, values);

  useEffect(() => {
    setValue(field.name, iban, { shouldValidate: true });
  }, [iban, field.name, setValue]);

  return field.hidden ? null : <TextField fullWidth disabled size="small" label={field.label} value={iban} />;
};

export default IbanField;
